import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Input, Label, Row, Button } from 'reactstrap';
import { getAPI, postAPI } from '../Base/API';
import { StyledCard, getLanguageOptions } from '../Base/Common/CommonUIComponents';
import OperatorDataSection from '../Base/Common/OperatorDataSection';
import CustomSelect from '../Base/Common/CustomSelect';
import { handleNotification } from "../Base/Common/Notification";
import { FormattedMessage, injectIntl } from 'react-intl';
import { DateRangePicker } from 'react-dates';
import moment from "moment";
import { calcValidUntilDate, getHotelLanguageCode, getRightVoucherId } from '../Base/Common/ReferenceDataFunctions';
import ProfileInfoSection from '../Base/Common/ProfileInfoSection';

class AddVoucher extends Component {
    static displayName = AddVoucher.name;
    _isMounted = false;
    constructor(props) {
        super(props);
        this.form = React.createRef();
        this.state = {
            block: true,
            voucherConfigList: [],
            voucherList: [],
            voucher: {
                voucherTypeIds: [
                    {
                        voucherTypeId: null,
                        quantity: 1,
                        voucherSalePrice: null
                    }
                ],
                HostPaymentCodes: [
                    {
                        hostPaymentCode: null,
                        amount: null
                    }
                ],
                languageCode: getHotelLanguageCode(),
                hotelId: global.defaultProperty
            },
            voucherConfig: {},
            paymentMethods: [],
            pmsUsers: [],
            registerSalesInPms: false,
            voucherChannels: [],
            cancelationModal: false,
            maxValidTo: null,
            chargeToRoom: false,
            // resident rooms already fetched, keyed by hotelId, so switching hotels back and forth
            // does not call the PMS again while the modal is open
            roomsByHotel: {},
            blockRooms: false
        }
    }

    componentDidMount() {
        const { voucher } = this.state;
        const { selectedVoucher } = this.props;

        const maxValidTo = calcValidUntilDate(selectedVoucher.vouchersValidUntil, selectedVoucher.validUntilUnit, selectedVoucher.validUntilFixedDate);
        
        voucher.voucherValue = selectedVoucher.voucherValue;
        voucher.vouchersValidFrom = moment();
        voucher.vouchersValidUntil = maxValidTo;
        voucher.voucherTypeIds[0].voucherTypeId = selectedVoucher.voucherTypeId;
        voucher.voucherTypeIds[0].voucherSalePrice = selectedVoucher.salePrice;
        voucher.HostPaymentCodes[0].amount = selectedVoucher.salePrice;
        voucher.dailyValueLimit = selectedVoucher.dailyValueLimit;
        voucher.isPaymentMode = selectedVoucher.isPaymentMode;

        this.setState({ voucher, voucherChannels: selectedVoucher.channels, maxValidTo });

        this.getConfig();
    }

    getConfig() {
        this.setState({ block: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                let arr = [];
                data.response && data.response.forEach((el) => {
                    if (moment().diff(moment(el.saleValidTo), 'days') <= 0) {
                        arr.push({ value: el.id, label: el.code, channels: el.channels })
                    }
                })

                const voucherConfig = data.response.find(el => el.id === this.state.voucher.voucherTypeId)
                const registerSalesInPms = data.response && data.response.length > 0 ? data.response[0].registerSalesInPms : false

                const selectedType = data.response.find(el => el.id === this.state.voucher.voucherTypeIds[0].voucherTypeId);
                const creationValidHotels = (selectedType && selectedType.creationValidHotels) || [];
                const voucher = { ...this.state.voucher };
                if (voucher.hotelId && !creationValidHotels.some(h => h.guid === voucher.hotelId)) {
                    voucher.hotelId = null;
                }

                this.setState({ voucher, voucherConfigList: arr, voucherConfig, voucherList: data.response, registerSalesInPms, block: false });
            }
        }, '/api/Voucher/V1/Config');
    }

    // fetches the resident rooms of the emission hotel, once per hotel while the modal is open
    loadRoomList = (hotelId) => {
        if (!hotelId || this.state.roomsByHotel[hotelId]) {
            return;
        }

        this.setState({ blockRooms: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                this.setState({ blockRooms: false });

                return;
            }
            if (data) {
                // business errors (hotel without PMS connectivity, hotel outside the group, ...)
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ blockRooms: false });

                    return;
                }

                const list = (data.response || []).map(el => {
                    const roomNumber = el.roomNumber ?? el.RoomNumber ?? el.room ?? '';
                    const guestName = el.guestName ?? el.GuestName ?? el.guestFullName ?? '';
                    const folio = el.roomFolio ?? el.RoomFolio;

                    return {
                        value: folio,
                        label: guestName ? `${roomNumber} - ${guestName}` : `${roomNumber}`,
                        roomFolio: folio
                    };
                });

                this.setState(prevState => ({
                    roomsByHotel: { ...prevState.roomsByHotel, [hotelId]: list },
                    blockRooms: false
                }));
            }
            else {
                this.setState({ blockRooms: false });
            }
        }, `/api/Voucher/v1/Config/pms/roomList/${hotelId}`);
    }

    // the emission hotel changed: a folio only makes sense in the hotel it belongs to
    handleHotelChange = (hotelId) => {
        const { voucher, chargeToRoom } = this.state;

        if (voucher.hotelId === hotelId) {
            return;
        }

        voucher.hotelId = hotelId;
        voucher.roomFolio = null;
        this.setState({ voucher }, () => {
            if (chargeToRoom) {
                this.loadRoomList(hotelId);
            }
        });
    }

    // toggles between paying (default) and charging the amount to a resident room folio
    handlePaymentDestinationChange = (chargeToRoom) => {
        const { voucher } = this.state;

        if (chargeToRoom) {
            // charging to the room hides payment method/cashbox, so clear them
            voucher.hostUserCashboxCode = null;
            voucher.HostPaymentCodes[0].hostPaymentCode = null;
            this.setState({ chargeToRoom: true, voucher }, () => this.loadRoomList(voucher.hotelId));
        }
        else {
            // keeping 'Pay' means no RoomFolio is sent and the current flow is preserved
            voucher.roomFolio = null;
            this.setState({ chargeToRoom: false, voucher });
        }
    }

    handleRoomSelect = (combo) => {
        const { voucher } = this.state;
        voucher.roomFolio = combo ? combo.value : null;
        this.setState({ voucher });
    }


    handleChange(evt) {
        let name = evt.target.name;
        let value = evt.target.value;

        this.setState(prevState => ({
            ...prevState,
            voucher: {
                ...prevState.voucher,
                [name]: value

            },
        }));
    }

    handleDateRangeChange = (startDate, endDate) => {
        this.setState(prevState => ({
            ...prevState,
            voucher: {
                ...prevState.voucher,
                vouchersValidFrom: startDate,
                vouchersValidUntil: endDate

            },
        }));

    }

    updateFilterCombo(val, evt) {
        if (evt) {
            const value = val.value;

            const v = this.state.voucherList.find(el => el.id === value);

            if (v) {
                const { voucher } = this.state;
                voucher.voucherValue = v.cardAmount;
                voucher.voucherTypeIds[0].voucherTypeId = v.id;
                voucher.voucherTypeIds[0].voucherSalePrice = v.payedAmount;
                voucher.HostPaymentCodes[0].amount = v.payedAmount;
                voucher.vouchersValidUntil = calcValidUntilDate(v.vouchersValidUntil, v.validUntilUnit, v.validUntilFixedDate);
                voucher.isPaymentMode = v.isPaymentMode;

                const creationValidHotels = v.creationValidHotels || [];
                if (!creationValidHotels.some(h => h.guid === voucher.hotelId)) {
                    // the hotel is no longer valid for this type, and so is any room selected in it
                    voucher.hotelId = null;
                    voucher.roomFolio = null;
                }

                // a voucher type with no (or zero) sale price can't be charged to a room;
                // reset 'Charge to room' and the selected room back to 'Pay'
                const chargeToRoom = v.payedAmount > 0 ? this.state.chargeToRoom : false;
                if (!chargeToRoom) voucher.roomFolio = null;

                this.setState({ voucher, chargeToRoom, voucherChannels: val.channels, maxValidTo: calcValidUntilDate(v.vouchersValidUntil, v.validUntilUnit, v.validUntilFixedDate) });
            }
        }
    }

    getValidHotelOptions() {
        const typeId = this.state.voucher.voucherTypeIds[0].voucherTypeId;
        const type = this.state.voucherList.find(el => el.id === typeId);
        const creationValidHotels = (type && type.creationValidHotels) || [];

        return creationValidHotels.map(el => ({ value: el.guid, label: el.name || el.Name }));
    }

    // returns a translation id explaining why this voucher type cannot be emitted, or null if it can
    getEmissionBlockReason() {
        // type not available on the direct sale channel
        if (this.state.voucherChannels && !this.state.voucherChannels.some(c => c.channelConfigId === 2)) {
            return "AddVoucher.ChannelNotAvailable";
        }

        const typeId = this.state.voucher.voucherTypeIds[0].voucherTypeId;
        const type = this.state.voucherList.find(el => el.id === typeId);
        if (type && (!type.creationValidHotels || type.creationValidHotels.length === 0)) {
            return "AddVoucher.NoValidHotelsForType";
        }

        return null;
    }

    handleSelect = (val, evt) => {
        if (evt) {
            let name = evt.name;
            let value = val.value;

            if (name === 'hostUserCode') {
                this.setState(prevState => ({
                    ...prevState,
                    voucher: {
                        ...prevState.voucher,
                        hostUserCashboxCode: null
                    },
                }));
            }

            this.setState(prevState => ({
                ...prevState,
                voucher: {
                    ...prevState.voucher,
                    [name]: value
                },
            }));
        }
    }

    saveVoucher(e) {
        e.preventDefault();

        var body = { ...this.state.voucher };
        body.hostPaymentCode = parseInt(body.salePrice) > 0 ? body.hostPaymentCode : null;


        if (this.form.current.reportValidity()) {
            const selectedType = this.state.voucherList.find(el => el.id === this.state.voucher.voucherTypeIds[0].voucherTypeId);
            const creationValidHotels = (selectedType && selectedType.creationValidHotels) || [];
            if (!this.state.voucher.hotelId || !creationValidHotels.some(h => h.guid === this.state.voucher.hotelId)) {
                handleNotification({ errors: [{ message: this.props.intl.formatMessage({ id: "AddVoucher.HotelNotValidForType" }), code: "" }] });
                return;
            }

            // when charging to a room, a valid RoomFolio must be selected
            if (this.state.chargeToRoom && !(this.state.voucher.roomFolio > 0)) {
                handleNotification({ errors: [{ message: this.props.intl.formatMessage({ id: "AddVoucher.SelectRoomRequired" }), code: "" }] });
                return;
            }

            // only send RoomFolio when charging to a room; keeping 'Pay' preserves the current flow
            const request = { ...this.state.voucher };
            if (!this.state.chargeToRoom) {
                delete request.roomFolio;
            }

            this.setState({ block: true });

            postAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    if (error.request && error.request.status === 504) {
                        handleNotification({}, <FormattedMessage id="AddVoucher.TimeoutConsultLogs" />, <FormattedMessage id="generic.timeout" />, 'info');
                    }
                    else {
                        errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    }
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                    }
                    else if (data.warnings && data.warnings.length > 0) {
                        handleNotification(data);
                        handleNotification({}, <FormattedMessage id="AddVoucher.VoucherCreatedSucessfuly" />, <FormattedMessage id="AddVoucher.Success" />);
                    }
                    else {
                        handleNotification(data, <FormattedMessage id="AddVoucher.VoucherCreatedSucessfuly" />, <FormattedMessage id="AddVoucher.Success" />);
                    }
                    this.setState({ block: false }, () => {
                        if(this.props.operations)
                            this.props.getVouchers();
                        else
                            this.props.setSoldVouchers(data.response ? data.response : []);
                    });
                }
                else {
                    this.setState({ error: errorMessage, block: false });
                }
            }, '/api/Voucher/Voucher/v1/voucher', { "request": request });
        }
    }

    handleSalePriceChange(evt) {
        if (evt.target) {
            const { value } = evt.target;
            const { voucher } = this.state;
            voucher.voucherTypeIds[0].voucherSalePrice = value;
            voucher.HostPaymentCodes[0].amount = value * voucher.voucherTypeIds[0].quantity;

            // 'Charge to room' only makes sense with a sale price > 0; reset it (and the
            // selected room) back to 'Pay' when the price becomes <= 0, empty or null
            const chargeToRoom = value > 0 ? this.state.chargeToRoom : false;
            if (!chargeToRoom) voucher.roomFolio = null;

            this.setState({ voucher, chargeToRoom });
        }
    }

    handlePaymentCodeSelect = (val, evt) => {
        if (evt) {
            const { value }= val;
            const { voucher } = this.state;
            voucher.HostPaymentCodes[0].hostPaymentCode = value;

            this.setState({ voucher });
        }
    }

    handleQuantityChange(evt) {
        if (evt && evt.target) {
            const { value } = evt.target;
            const { voucher } = this.state;
            voucher.voucherTypeIds[0].quantity = parseInt(value);
            voucher.HostPaymentCodes[0].amount = voucher.voucherTypeIds[0].voucherSalePrice * voucher.voucherTypeIds[0].quantity;
            this.setState({ voucher });
        }
    }
    
    updateVoucherData = (voucherData) => {
        this.setState({ voucher: voucherData });
    }

    handleLanguageCode = (combo, evt) => {
        if (evt) {
            const { voucher } = this.state;
            voucher.languageCode = combo && combo.value;
            this.setState({ voucher });
        }
    }

    render() {
        const blockReason = this.getEmissionBlockReason();
        const isSold = this.props.soldVouchers?.length > 0;
        const hotelOptions = this.getValidHotelOptions();

        return (
            <StyledCard icon={'fa-solid fa-gift'} title={'AddVoucher.title'} error={this.state.error} block={this.state.block}>
                {this.state.voucher ?
                    <form ref={this.form}>
                        <Row>
                            <Col>
                                {
                                    this.props.soldVouchers?.map((soldVoucher, key) =>
                                        <div key={key} className="mb-4">
                                            <b><FormattedMessage id="AddVoucher.soldVoucher" /> </b>  <Link to={`/VoucherOperationDetails/${soldVoucher.id}`} style={{ cursor: "pointer", color: "blue" }}> {getRightVoucherId(soldVoucher.voucherId, soldVoucher.voucherIdFirst8)} </Link>
                                        </div>
                                    )
                                }
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <Label>
                                    <FormattedMessage id="AddVoucher.SelectLanguage" />
                                </Label>
                            </Col>
                            <Col className="col-4">
                                <CustomSelect options={getLanguageOptions()} value={getLanguageOptions().find(lOpt => lOpt.value === this.state.voucher.languageCode) || ''} onChange={this.handleLanguageCode} />
                            </Col>
                            <Col className="col-2">
                                <Label>
                                    <FormattedMessage id="generic.Hotel" />
                                </Label>
                            </Col>
                            <Col className="col-4">
                                <CustomSelect
                                    name="hotelId"
                                    placeholder={<FormattedMessage id="generic.Hotel" />}
                                    options={hotelOptions}
                                    value={hotelOptions.find(el => el.value === this.state.voucher.hotelId) || ''}
                                    onChange={(val, evt) => {
                                        if (val) {
                                            this.handleHotelChange(val.value);
                                        }
                                    }}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col className="col-2">
                                <Label>
                                    <FormattedMessage id="generic.VoucherType" />
                                </Label>
                            </Col>
                            <Col className="col-4">
                                <CustomSelect
                                    options={this.state.voucherConfigList}
                                    value={this.state.voucherConfigList.find(el => el.value === this.state.voucher.voucherTypeIds[0].voucherTypeId) || ''}
                                    name="voucherTypeId"
                                    onChange={this.updateFilterCombo.bind(this)}
                                    placeholder={<FormattedMessage id="generic.VoucherType" />}
                                    required
                                />
                            </Col>
                            <Col className="col-2">
                                <Label>
                                    <FormattedMessage id="generic.Quantity" />
                                </Label>
                            </Col>
                            <Col className="col-4">
                                <Input type="number" id="quantity" name="quantity" value={this.state.voucher.voucherTypeIds[0].quantity || ''} onChange={this.handleQuantityChange.bind(this)} min="1" required />
                            </Col>
                        </Row>


                        <Row className="align-items-center">
                            <Col>
                                <h5>
                                    <FormattedMessage id="AddVoucher.Price&Validity" />
                                </h5>
                            </Col>
                            {this.state.voucher.dailyValueLimit ?
                                <Col className="text-right font_size_xxs">      
                                    <span><FormattedMessage id="EditVoucher.DailyValueLimit" />: </span>
                                    <span>
                                        {this.state.voucher.dailyValueLimit}
                                    </span>
                                </Col>
                            : ''}
                        </Row>
                        <hr className="mb-3 mt-0" />
                        <Row className="mb-2">
                            <Col className="col-2"><Label><FormattedMessage id="generic.salePrice" /></Label></Col>
                            <Col>
                                <FormattedMessage id="generic.salePrice">
                                    {
                                        placeholder =>
                                            <Input
                                                type="number"
                                                required
                                                value={this.state.voucher.voucherTypeIds[0].voucherSalePrice ?? ''}
                                                name="salePrice"
                                                onChange={this.handleSalePriceChange.bind(this)}
                                                placeholder={placeholder}
                                                min={0}
                                                step="0.01"
                                            />
                                    }
                                </FormattedMessage>
                            </Col>
                            <Col className="col-2"><Label><FormattedMessage id="generic.voucherValue" /></Label></Col>
                            <Col>
                                <FormattedMessage id="generic.voucherValue">
                                    {
                                        placeholder => <Input 
                                        type="number" 
                                        required 
                                        value={this.state.voucher.voucherValue !== null ? this.state.voucher.voucherValue : ''} 
                                        name="voucherValue" 
                                        onChange={this.handleChange.bind(this)} 
                                        placeholder={placeholder} 
                                        min={this.state.voucher.isPaymentMode ? 0 : 0} 
                                        step="0.01"
                                        />
                                    }
                                </FormattedMessage>
                            </Col>                            
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2"><Label><FormattedMessage id="generic.invoice" /></Label></Col>
                            <Col className="col-4">
                                <FormattedMessage id="generic.invoice">
                                    {
                                        placeholder => <Input type="text" value={this.state.voucher.invoiceReference || ''} name="invoiceReference" onChange={this.handleChange.bind(this)} placeholder={placeholder} />
                                    }
                                </FormattedMessage>
                            </Col>
                            <Col className="col-2">
                                <Label>
                                    <FormattedMessage id="VoucherOperationDetails.Vality" />
                                </Label>
                            </Col>
                            <Col className="col-4">
                                <DateRangePicker
                                    startDateId="vouchersValidFrom"
                                    startDate={this.state.voucher && this.state.voucher.vouchersValidFrom ? this.state.voucher.vouchersValidFrom : null}
                                    isOutsideRange={day => day < moment() || day > this.state.maxValidTo}
                                    endDate={this.state.voucher && this.state.voucher.vouchersValidUntil ? this.state.voucher.vouchersValidUntil : null}
                                    endDateId="vouchersValidUntil"
                                    onDatesChange={({ startDate, endDate }) => this.handleDateRangeChange(startDate, endDate)}
                                    focusedInput={this.state.focusedInput}
                                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                                    small={true}
                                    required
                                    numberOfMonths={1}
                                    showDefaultInputIcon={true}
                                />
                            </Col>
                        </Row>
                        {global.modules?.some(m => m === "VoucherRFID") ?
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label><FormattedMessage id="VoucherOperationDetails.RfId" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="VoucherOperationDetails.RfId" >
                                        {
                                            placeholder => <Input
                                                type="text"
                                                name="rfId"
                                                placeholder={placeholder}
                                                value={this.state.voucher?.rfId || ''}
                                                onChange={this.handleChange.bind(this)}
                                                maxLength={100}
                                            />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                        : ''}
                        <Row>
                            <Col className="col-2">
                                <Label>
                                    <FormattedMessage id="generic.notes" />
                                </Label>
                            </Col>
                            <Col className="col-10">
                                <FormattedMessage id="generic.notes">
                                    {
                                        placeholder => <Input type="textarea" value={this.state.voucher.notes !== null ? this.state.voucher.notes : ''} name="notes" onChange={this.handleChange.bind(this)} placeholder={placeholder} />
                                    }
                                </FormattedMessage>
                            </Col>
                        </Row>


                        <ProfileInfoSection
                            voucher={this.state.voucher}
                            handleChange={this.handleChange.bind(this)}
                            handleSelect={this.handleSelect.bind(this)}
                            updateVoucherData={this.updateVoucherData.bind(this)}
                            fiscalNumberRequired={this.state.registerSalesInPms && this.state.voucher.voucherTypeIds[0].voucherSalePrice > 0}
                        />


                        {this.state.registerSalesInPms && this.state.voucher.voucherTypeIds[0].voucherSalePrice > 0 ? (
                            <OperatorDataSection
                                operatorData={{
                                    hostUserCode: this.state.voucher.hostUserCode,
                                    hostUserCashboxCode: this.state.voucher.hostUserCashboxCode,
                                    hostUserPassword: this.state.voucher.hostUserPassword,
                                    HostPaymentCodes: this.state.voucher.HostPaymentCodes
                                }}
                                handleSelect={this.handleSelect.bind(this)}
                                handlePaymentCodeSelect={this.handlePaymentCodeSelect.bind(this)}
                                handleHostUserPass={this.handleChange.bind(this)}
                                showPaymentDestination
                                chargeToRoom={this.state.chargeToRoom}
                                roomFolio={this.state.voucher.roomFolio}
                                rooms={this.state.roomsByHotel[this.state.voucher.hotelId] || []}
                                blockRooms={this.state.blockRooms}
                                onPaymentDestinationChange={this.handlePaymentDestinationChange}
                                onRoomSelect={this.handleRoomSelect}
                            />
                        ) : ''}

                        <Row className="mt-4 align-items-center">
                            <Col className="text-left">
                                {blockReason &&
                                    <span className="text-warning font_size_xxs">
                                        <i className="fa-solid fa-triangle-exclamation mr-1" />
                                        <FormattedMessage id={blockReason} />
                                    </span>
                                }
                            </Col>
                            <Col className="text-right">
                                <Button className="btn-host btn-sm" onClick={this.saveVoucher.bind(this)} disabled={blockReason !== null || isSold}>
                                    <i className="fa-solid fa-floppy-disk " />
                                </Button>
                            </Col>
                        </Row>
                    </form>
                    :
                    ''
                }
            </StyledCard>
        )
    }
}
export default injectIntl(AddVoucher);